import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UiComponentsModule } from '@mwe/ui/components';
import { UiPipesModule } from '@mwe/ui/pipes';
import { ProductAddFooterComponent } from './product-add-footer/product-add-footer.component';
import { ProductAddWizardBaseComponent } from './wizard/product-add-wizard-base.component';
import { RouterModule } from '@angular/router';
import { ProductsSearchBaseComponent } from './products-search/products-search-base.component';
import { ProductChooseBaseComponent } from './product-choose/product-choose-base.component';
import { NoBirthdateInSapComponent } from './no-birthdate-in-sap/no-birthdate-in-sap.component';

const components = [
  ProductAddFooterComponent,
  ProductAddWizardBaseComponent,
  ProductsSearchBaseComponent,
  ProductChooseBaseComponent,
  NoBirthdateInSapComponent,
];

const modules = [CommonModule, TranslateModule, UiComponentsModule, UiPipesModule, RouterModule];

@NgModule({
  imports: [...modules, ...components],
  exports: [...components, ...modules],
})
export class BaseProductAddModule {}
